import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
`;

export const SelectButton = styled.button`
  background: transparent;
  border: 2px solid ${({ theme }) => theme.colors.accent};
  color: ${({ theme }) => theme.colors.accent};
  padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.md};
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  cursor: pointer;
  transition: background-color 0.3s ease, color 0.3s ease;
  border-radius: 4px;
  font-family: ${({ theme }) => theme.fonts.primary};
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;

  &:hover {
    background: ${({ theme }) => theme.colors.accent};
    color: ${({ theme }) => theme.colors.dark};
  }

  svg { width: 14px; height: 14px; }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: ${({ theme }) => theme.spacing.xs} ${({ theme }) => theme.spacing.sm};
    font-size: 0.75rem;
  }
`;

export const Dropdown = styled.ul<{ $dropUp?: boolean }>`
  position: absolute;
  ${({ $dropUp }) => ($dropUp
    ? 'bottom: calc(100% + 8px); top: auto; left: 0; right: auto; max-width: calc(85vw - 3rem);'
    : 'top: calc(100% + 8px); bottom: auto; right: 0; left: auto;')}
  z-index: 1200;
  margin: 0;
  padding: 0.4rem 0;
  list-style: none;
  background: #161616;
  border: 1px solid rgba(184, 150, 74, 0.4);
  border-radius: 8px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.35);
  min-width: 200px;
  max-height: 320px;
  overflow-y: auto;
`;

export const Item = styled.li<{ $active: boolean }>`
  padding: 0.5rem 1rem;
  font-size: 0.85rem;
  color: ${({ $active, theme }) => ($active ? theme.colors.accent : '#d4d4cc')};
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  transition: background-color 0.15s ease, color 0.15s ease;

  .name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &:hover {
    background: rgba(184, 150, 74, 0.14);
    color: ${({ theme }) => theme.colors.accent};
  }

  .rate {
    color: #9a9a92;
    font-size: 0.78rem;
    white-space: nowrap;
    flex-shrink: 0;
  }
`;
